import { EmailOptInRepository } from '../repositories/EmailOptInRepository';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/CommunicationsService';
import { EmailOptIn } from '../domain/entities/EmailOptIn';

export class EmaiOptInViewLoadedUseCase {
    private emailOptInRepository: EmailOptInRepository;

    constructor() {
        this.emailOptInRepository = diContainer.get(serviceNames.emailOptInRepository);
    }

    public execute = async () => {
        try {
            const emailOptIn = new EmailOptIn();
            this.emailOptInRepository.setInternalEmailOptIn(emailOptIn);
        } catch (error) {
            console.error(error);
        }
    };
}
